export default __webpack_public_path__ + "static/zellij_pattern_1-23a04f2ef1cdfbcc21b8c8d90b12fd38.png";